
import { CoverSection } from '../components/brakePadsPage/coverSection/CoverSection';
import { MainSection } from '../components/brakePadsPage/mainSection/MainSection';

export function BrakePadsPage() {
  return (
    <>
      <CoverSection />
      <MainSection />
    </>
  );
}
